import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ApiClientProvider } from '@rudi/api/react';
import { AuthProvider, useAuth } from '@rudi/auth';
import { Toaster } from 'sonner';
import './styles/globals.css';

import { router } from './router';
import { apiClient } from './platform/api-client';
import { cortexAdapter } from './platform/adapter';
import { persistUser, readInitialState } from './platform/auth-storage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 1000 * 30, retry: 1 },
  },
});

/**
 * Persists the authenticated user to localStorage so a reload can rehydrate the
 * session synchronously (the @rudi/auth client only stores tokens itself).
 */
function SessionPersist() {
  const { user } = useAuth();
  useEffect(() => {
    if (user) persistUser(user);
  }, [user]);
  return null;
}

const initialState = readInitialState();

const App = (
  <QueryClientProvider client={queryClient}>
    <ApiClientProvider client={apiClient}>
      <AuthProvider adapter={cortexAdapter} initialState={initialState}>
        <SessionPersist />
        <RouterProvider router={router} />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ApiClientProvider>
  </QueryClientProvider>
);

const rootElement = document.getElementById('root');
if (rootElement && !rootElement.innerHTML) {
  ReactDOM.createRoot(rootElement).render(App);
}
